import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThreatModel = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.35 0.25H0.25V5.35H2.05005V12.6499H0.25V17.7499H5.35V15.95H12.6499V17.7499H17.7499V12.6499H15.95V5.35H17.7499V0.25H12.6499V2.05005H5.35V0.25ZM12.6499 12.6499V14.45H5.35V12.6499H3.55005V5.35H5.35V3.55005H12.6499V5.35H14.45V12.6499H12.6499ZM1.75 3.85V1.75H3.85V3.85H1.75ZM1.75 16.2499V14.1499H3.85V16.2499H1.75ZM14.1499 1.75V3.85H16.2499V1.75H14.1499ZM14.1499 14.1499V16.2499H16.2499V14.1499H14.1499ZM8.25 9.34091V5.25H9.75V9.34091H8.25ZM10 11.7273C10 12.2922 9.55228 12.75 9 12.75C8.44772 12.75 8 12.2922 8 11.7273C8 11.1625 8.44772 10.7046 9 10.7046C9.55228 10.7046 10 11.1625 10 11.7273Z",
		fill: "currentColor"
	})
});
export default SvgThreatModel;
